@if (shouldDisplay()) {
  <div #tooltip id="tooltip"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
    >
    @if (tooltipAtBottom) {
      <div id="arrow-up"></div>
    }
    <div #tooltipInfo id="tooltip-info">
      <p>Contrast ratio: {{contrastRatio}}</p>
      <p>Text: {{text}}</p>
      <div class="btn-group">
        <button pButton class="p-button-text" (click)="paintFg()">Show contrast color1</button>
        <button pButton class="p-button-text" (click)="paintBg()">Show contrast color2</button>
      </div>
      <div class="btn-group">
        <button pButton class="p-button-text" (click)="paintFgMask()">Show layer1</button>
        <button pButton class="p-button-text" (click)="paintBgMask()">Show layer2</button>
      </div>
      <div>
        <button pButton class="p-button-text" (click)="resetPaints()">Reset</button>
      </div>
    </div>
    @if (!tooltipAtBottom) {
      <div id="arrow-down"></div>
    }
  </div>
}
@if (shouldDisplay()) {
  <div #highlight id="highlight"
    [style.left.px]="highlightX"
    [style.top.px]="highlightY"
    [style.width.px]="highlightW"
    [style.height.px]="highlightH"
  ></div>
}
